import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SEO_DEFAULT = {
  title: 'NXP SSO',
}

export const RouteChangeHandler = () => {
  const location = useLocation()

  useEffect(() => {
    document.title = SEO_DEFAULT.title
  }, [location])

  return null
}
